<script setup lang="ts">
import EntitySidebarField from '@/modules/Project/Entity/EntitySidebarField.vue'
import EntitySidebarFieldContainer from '@/modules/Project/Entity/EntitySidebarFieldContainer.vue'
import CollectionField from '@/modules/Project/Fields/registry/collection/CollectionField.vue'
import { useResolveProjectRoute } from '@/modules/Project/useResolveProjectRoute'
import { useWorkspaceContext } from '@/modules/Workspaces/useWorkspaceContext'
import DarwinButton from '@/uiKit/DarwinButton.vue'
import IconSprite from '@/uiKit/IconSprite.vue'
import { computed } from 'vue'
import type { SidebarEmits, SidebarProps } from '../../field-types'

const props = defineProps<SidebarProps<'collection'>>()
defineEmits<SidebarEmits<'collection'>>()

const { workspaceId } = useWorkspaceContext()

const resolveProjectRoute = useResolveProjectRoute()

const projectRoute = computed(() =>
  resolveProjectRoute({
    projectId: props.property.config.subprojectConfig.child_project_id,
    workspaceId: workspaceId.value,
  }),
)
</script>

<template>
  <EntitySidebarField
    :field="field"
    :property="property"
  >
    <template #actions>
      <DarwinButton
        :to="projectRoute"
        size="xs"
        variant="transparent"
      >
        <template #leading-icon>
          <IconSprite icon="table" />
        </template>
        Open in table view
      </DarwinButton>
    </template>
    <template #field="{ labelId }">
      <EntitySidebarFieldContainer class="pl-3">
        <CollectionField
          :property="property"
          :field="field"
          :aria-labelledby="labelId"
          @submit="$emit('submit', $event)"
          @focus="$emit('focus', $event)"
          @blur="$emit('blur', $event)"
          @show-source="$emit('show-source', $event)"
        />
      </EntitySidebarFieldContainer>
    </template>
  </EntitySidebarField>
</template>
